import { jsx as a, Fragment as d } from "react/jsx-runtime";
import l from "clsx";
import { createSpaceClassName as f } from "./withSpace.js";
const u = (n) => {
  const {
    asMargin: o,
    negative: s,
    className: r,
    component: c = "div",
    children: e,
    htmlId: m,
    dataTestId: i,
    ...p
  } = n, t = l(f(p, { asMargin: o, negative: s }), r);
  return typeof e == "function" ? /* @__PURE__ */ a(d, { children: e(t) }) : /* @__PURE__ */ a(c, { className: t, id: m, "data-testid": i, children: e });
};
export {
  u as Space
};
